import styled from "styled-components";

export const Container = styled.div`
	font-size: clamp(1px, 4dvw, 18px);
	margin: 1.25em auto 2.5em;
	padding: 2.2em 1.5em 2em;
	border-radius: 1.5em;
	background: rgba(255, 255, 255, 0.95);
	box-shadow: 0 0.75em 1.5em rgba(0, 0, 0, 0.25);
	text-align: center;
	width: 19.3125em;
	height: 17.625em;
	box-sizing: border-box;

	@media (orientation: landscape) {
		font-size: clamp(1px, 1.6dvw, 18px);
	}
`;

export const Title = styled.div`
	color: #113b62;
	text-align: center;
	font-family: Baloo;
	font-size: 3.25em;
	font-style: normal;
	font-weight: 400;
	line-height: 1em;
`;

export const Subtitle = styled.div`
	color: #333;
	text-align: center;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
`;

export const ButtonsContainer = styled.div`
	margin-top: 1.7em;
	width: 100%;
	max-width: 17em;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 0.8em;
	margin-left: auto;
	margin-right: auto;
`;

export const PrivacyLink = styled.a`
	display: inline-block;
	margin-top: 1em;
	font-size: 0.8em;
	font-family: Inter;
	font-style: normal;
	font-weight: 500;
	color: #333;
	text-decoration: none;
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-skip-ink: none;
`;
